var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6786 2.43262H17.9414C18.5264 2.43262 19 2.88622 19 3.44302V17.9894C19 18.5486 18.5264 18.9998 17.9414 18.9998H2.05857C1.47357 18.9998 1 18.5462 1 17.9894V3.44302C1 2.88382 1.47357 2.43262 2.05857 2.43262H4.42857",
    stroke: "#026094",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.14258 2.43262H13.964",
    stroke: "#026094",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1 6.11426H19",
    stroke: "#026094",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.55469 1H5.01897C4.69352 1 4.42969 1.29549 4.42969 1.66V3.6136C4.42969 3.97811 4.69352 4.2736 5.01897 4.2736H5.55469C5.88014 4.2736 6.14397 3.97811 6.14397 3.6136V1.66C6.14397 1.29549 5.88014 1 5.55469 1Z",
    stroke: "#026094",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.0898 1.10352H14.5541C14.2287 1.10352 13.9648 1.39901 13.9648 1.76352V3.71711C13.9648 4.08162 14.2287 4.37711 14.5541 4.37711H15.0898C15.4153 4.37711 15.6791 4.08162 15.6791 3.71711V1.76352C15.6791 1.39901 15.4153 1.10352 15.0898 1.10352Z",
    stroke: "#026094",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.8982 16.4433H4.32031V8.26172H15.6775V13.7841",
    stroke: "#026094",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.32227 8.46777V16.4454",
    stroke: "#026094",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.1074 8.46777V16.4454",
    stroke: "#026094",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.8926 8.46777V16.4454",
    stroke: "#026094",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M15.5709 11.127H4.53516",
    stroke: "#026094",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.5709 13.7852H4.53516",
    stroke: "#026094",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M10.2148 11.0234H7.21484V13.6826H10.2148V11.0234Z",
    fill: "#026094",
    stroke: "#026094",
    strokeMiterlimit: 10
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.fc91c9ad5d51a2c5ccf18db40536430b.svg";
export { ForwardRef as ReactComponent };